import { useCallback } from 'react'
import { FormikHelpers } from 'formik'
import { message } from 'antd'
import { useParams } from 'react-router-dom'
import { useBackgroundNavigate } from '@shared/hooks/use-background-navigate'
import { FormOptions } from '@shared/modules/form/types'

import { ProductsService } from '../services'
import { ProductFormData } from '../types'
import { useProductInitialValues } from './use-initial-values'

export const useProductForm = ({ type = 'create', redirectUrl }: FormOptions) => {
  const params = useParams<{ id?: string }>()
  const navigate = useBackgroundNavigate()

  const initialValues = useProductInitialValues(params.id)

  const onSubmit = useCallback(
    async (values: ProductFormData, helpers: FormikHelpers<ProductFormData>) => {
      helpers.setStatus(null)

      const result = await ProductsService.createOrUpdate(values, type)

      if (result.status === 200) {
        if (redirectUrl) {
          navigate(redirectUrl)
        } else {
          helpers.resetForm()
        }
        message.success('Məlumatlar müvəffəqiyyətlə yeniləndi.')
      } else if (result.status === 422) {
        helpers.setErrors(result.data)
      } else {
        helpers.setStatus({ type: 'error', message: result.data })
      }
    },
    [navigate, redirectUrl, type],
  )

  return { initialValues, onSubmit }
}
